import { useState, useEffect } from "react";
import axios from "axios";
import { NavLink } from "react-router-dom";
import { PlayCircleOutlined, TeamOutlined } from "@ant-design/icons";
import { Button } from "antd";

function Classrooms() {
  const [classes, setClasses] = useState([]);
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    const fetchData = async () => {
      const response = await axios.get(
        "https://api.projectrere.org/ClassRoom/GetAll?TeacherId=" + user.id
      );
      setClasses(response.data);
    };
    fetchData();
  }, []);
  console.log(classes);

  const handleNew = () => {
    window.location.href = "/ClassRooms/0";
  };
  return (
    <main>
      <header className="flex-row">
        <div>
          <h1>Classrooms</h1>
          <p>
            On this screen, users with the instructor role can create classes
            and add or remove students from these classes.
          </p>
        </div>
        <Button type="primary" onClick={handleNew}>
          New
        </Button>
      </header>
      <section className="scenarios">
        <div className="wrapper">
          <div className="cards">
            {classes.map((item) => {
              return (
                <NavLink
                  className="card"
                  to={`/classrooms/${item.id}`}
                  key={item.id}
                >
                  <TeamOutlined className="icon" />
                  <div className="card-body">
                    <p className="card-title">{item.title}</p>
                    <p className="card-desc">{item.students.length}</p>
                  </div>
                </NavLink>
              );
            })}
          </div>
        </div>
      </section>
    </main>
  );
}

export default Classrooms;
